export const APPOINTMENT_LINK_CHANGED = {
  title: 'Appointment link changed',
  subtitle: 'Please message your provider directly for an updated session link.',
  messageProvider: 'Message provider',
  forAdditionalSupport: 'For additional support, contact support from your',
  portal: 'portal',
};
